"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/top-app-bar/dist/mdc.top-app-bar.css");
require("@rmwc/icon-button/styles");
require("@rmwc/ripple/styles");
require("@rmwc/icon/styles");
